import clsx from 'clsx';
import React from 'react';

import Box from '@material-ui/core/Box';

import useStyles from './useStyles';

export default function Scrollable({ children, className, ...props }) {
  const classes = useStyles();

  return (
    <Box {...props} className={clsx(classes.root, className)}>
      {children}
    </Box>
  );
}
